import { createSelector, createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from '../common/reducers/utilities';

export const clientConfig = createSlice({
    name: 'clientConfig',
    initialState: {
        config: {},
    },
    reducers: {
        set: (state, action) => {
            state.config = action.payload ?? {}
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => clientConfig.getInitialState());
    }
});


const fetchConfig = token => network => {
    network.get('/api/v1/clientConfig', clientConfig.actions.set);
}

const makeBuildClientConfig = createSelector([state => state.clientConfig.config, (state, token) => token], (clientConfig, token) => {
    clientConfig = JSON.parse(JSON.stringify(clientConfig));
    if (clientConfig.memberRequiresRosterConfirmation) {
        clientConfig.memberRequiresRosterConfirmation = eval(clientConfig.memberRequiresRosterConfirmation);
    }
    if (clientConfig.memberCanRejectRoster) {
        clientConfig.memberCanRejectRoster = eval(clientConfig.memberCanRejectRoster);
    }
    if (clientConfig.expressionOfInterest?.enable) {
        clientConfig.expressionOfInterest.convertToMember = eval(clientConfig.expressionOfInterest.convertToMember);
    }
    if (clientConfig.calculateActualRosterTimes) {
        clientConfig.calculateActualRosterTimes = eval(clientConfig.calculateActualRosterTimes);
    }
    if (clientConfig.eventHoursRange) {
        clientConfig.eventHoursRange = eval(clientConfig.eventHoursRange);
    }
    if (clientConfig.payTools) {
        Object.keys(clientConfig.payTools).forEach(func => clientConfig.payTools[func] = eval(clientConfig.payTools[func]));
    }
    if (clientConfig.rosterCustomValidation) {
        clientConfig.rosterCustomValidation.forEach(v => v.validate = eval(v.validate));
    }
    if (clientConfig.genRosterSuffix) {
        clientConfig.genRosterSuffix = eval(clientConfig.genRosterSuffix);
    } else {
        clientConfig.genRosterSuffix = function (member, accreditation, addZeroWidthSpaces) {
            let toReturn = '';
            const space = addZeroWidthSpaces ? '\u200B;' : '';
            if (accreditation) {
                if (accreditation.accred) {
                    toReturn += accreditation.accred.shortname;
                }
                if (accreditation.supp && accreditation.supp.length > 0) {
                    toReturn += space + '+' + space + accreditation.supp.map(s => s.shortname).join(',' + space);
                }
            }
            return toReturn;
        };
    }
    return clientConfig
})
const buildClientConfig = token => state => makeBuildClientConfig(state, token)

const listen = {
    settingUpserted: (_, { network }) => network.get('/api/v1/clientConfig', clientConfig.actions.set)
}
export const [useClientConfigImpl] = dataHookFactory(buildClientConfig, initMapFactory(fetchConfig, listen, { allowEmpty: true, authenticated: false }));

const reducerDetails = { name: clientConfig.name, reducer: clientConfig.reducer };
export default reducerDetails;